import { Component, inject } from '@angular/core';
import { PostavitevInfoDTO } from './postavitev-info.model';
import { IxNgBusyFormService, IxParentDTO, IxServiceBaseUtil } from 'ix-ng-components';
import { IxNgErrorHandlingService } from 'ix-ng-forms';
import { IxNgRoutingService } from 'ix-ng-routing';
import { IxKeycloakHttp, IxNgHttpService } from 'ix-ng-http';
import { Maybe } from 'ix-ng-static-utils';
import { BaseAppService } from 'vpo-shared';

@Component({
  selector: 'lib-postavitev-info',
  templateUrl: './postavitev-info.component.html',
})
export class PostavitevInfoComponent {
  public readService: IxServiceBaseUtil;
  public barva: Maybe<string>;
  public besedilo: Maybe<string>;

  constructor() {
    const ixNgErrorHandlingService = inject(IxNgErrorHandlingService);
    const ixNgRoutingService = inject(IxNgRoutingService);
    const ixKeycloakHttp = inject(IxKeycloakHttp);
    const ixNgHttpService = inject(IxNgHttpService);
    const ixNgBusyFormService = inject(IxNgBusyFormService);

    this.readService = new IxServiceBaseUtil(
      ixKeycloakHttp,
      ixNgRoutingService,
      ixNgErrorHandlingService,
      ixNgHttpService,
      ixNgBusyFormService,
    );

    this.readService.serviceUrl = BaseAppService.controllerUrl + '/postavitevInfo';

    this.readService.safeCall(
      () => this.readService.get('readPostavitev', undefined),
      (result: Maybe<IxParentDTO<PostavitevInfoDTO>>) => {
        if (result) {
          this.besedilo = result.row?.besedilo;
          this.barva = result.row?.barva;
        }
      },
    );
  }
}
